import React from 'react';
import { Button } from 'reactstrap'

const HandleSubmission = (props) => (
  <div className="text-center">                
    <Button className="btn mr-2" type="submit">Save</Button>
    {props.formType !== "edit" && <Button className="btn" onClick={props.resetForm}>Discard</Button>}
  </div>
)

export default HandleSubmission;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/HandleVitalSubmission.js